<div class="field-wrap">
    <mulo-datepicker
        (dateInputChange)="dateChange($event)"
        [dateInput]="dateInput"
        [error]="
            depositFormDataService.mainForm?.errors?.validDate ? ('research.status.error' | customTranslate) : null
        "
        [hint]="'research.status.date.hint' | translate: { value0: currentDate }"
        [label]="'research.status.date' | customTranslate"
        [prefixIcon]="isDateAutoPopulated ? 'auto-populate' : null"
        [prefixIconClass]="'auto-populate-icon'"
        [prefixIconTooltip]="'research.auto.populate.tooltip' | customTranslate"
        [required]="depositFormDataService[this.dateKey()]?.isRequired()"
        [requiredErrorLabel]="'research.output.list.error.message' | translate"
    >
    </mulo-datepicker>
    <mat-form-field class="margin-left-sm">
        <mat-label>{{ 'research.status.season' | customTranslate }}</mat-label>
        <mat-select [formControl]="depositFormDataService.seasonPublished">
            <mat-option [value]="''">{{ 'research.settings.research.none' | customTranslate }}</mat-option>
            @for (season of seasons; track season) {
                <mat-option [value]="season.code">
                    {{ season.code | translate }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
    <div></div>
</div>
